import { InputsFinalize } from "../models/InputsFinalize";

declare const config: { API_URL: string; FACILITY_IDS: string };

export const API_URL = (config && config.API_URL) || "http://localhost:8085/tt-rest";
export const FACILITY_IDS = (config && config.FACILITY_IDS) || "1215";

export const FAKE_LOGIN_USE_URL = "/EAktywni/session/fake";
export const GET_TICKETS = `/EAktywni/facility/tickets?objectIds=${FACILITY_IDS}`;
export const GET_PASSES = `/EAktywni/facility/passes?objectIds=${FACILITY_IDS}`;
export const GET_TICKETS_FOR_EXERCISE = `/EAktywni/facility/tickets/exercises?objectIds=${FACILITY_IDS}`;
export const GET_BASKET = "/EAktywni/basket";
export const ADD_TO_BASKET = "/EAktywni/addTicket";
export const REMOVE_FROM_BASKET = "/EAktywni/removeTicket/julinek";
export const REMOVE_FROM_WHOLE_BASKET = "/EAktywni/removeTicket";
export const BAD_WEATHER_CHECK_PASS = (trhId: string) =>
  `/EAktywni/badWeather/checkPass?facilityIds=${FACILITY_IDS}&trhId=${trhId}`;
export const BASKET_CALCULATE_PROMOTION = (promotionCode?: string, clear?: boolean) => {
  let url = `/EAktywni/basket/calculate/promotion/julinek?facilityIds=${FACILITY_IDS}`;
  if (promotionCode) {
    url += `&promotionCode=${promotionCode}`;
  }
  if (clear) {
    url += `&clear=true`;
  }
  return url;
};

export const ACCEPT_FINALIZE = (form: InputsFinalize) => {
  let url = `/EAktywni/saveReservation?name=${form.firstName}&lastName=${form.lastName}&email=${form.email}&phone=${form.phone}&zipCode=${form.zipCode}&createUser=false`;
  if (form.createInvoice) {
    url += `&createInvoice=${form.createInvoice}&companyName=${form.companyName}&NIP=${form.NIP}&street=${form.street}&city=${form.city}&houseNumber=${form.houseNumber}&flatNumber=${form.flatNumber}`;
  }

  return url;
};

export const GET_CALENDAR_DATA = (dateFrom: string, dateTo: string) =>
  `/EAktywni/attractions/calendar/julinek?objectIds=${FACILITY_IDS}&dateFrom=${dateFrom}&dateTo=${dateTo}`;

export const GET_EXERCISE_FOR_DATE = (date: string, exerciseGroupIds: string) =>
  `/EAktywni/exercises/datesAndFacility?objectIds=${FACILITY_IDS}&date=${date}&exerciseGroupId=${exerciseGroupIds}`;

export const ADD_EXERCISE_TO_BASKET = (exerciseIds: string) =>
  `/EAktywni/julinek/addExerciseToBasket?objectIds=${FACILITY_IDS}&exerciseIds=${exerciseIds}`;

export const CLEAR_BASKET = `/EAktywni/clearbasket?objectIds=${FACILITY_IDS}`;
export const EXERCISE_BASKET_CLEAR = `/EAktywni/julinek/addExerciseToBasket?objectIds=${FACILITY_IDS}&clear=true`;
export const CHANGE_ZONE_SELECT_TO_LIMITED = `/EAktywni/julinek/basket/select2limited?objectIds=${FACILITY_IDS}`;
export const USE_PASS = (trhId: string) => `/EAktywni/julinek/pass/execute?objectIds=${FACILITY_IDS}&passCode=${trhId}`;
export const LAST_TRANSACTION = `/EAktywni/julinek/lastTransaction?objectIds=${FACILITY_IDS}`;
